var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'ss__desktop__submenu__item',
    _vm.submenu.layout ? `ss__desktop__submenu__item--${_vm.submenu.layout}` : ''],style:(_vm.submenu.style)},[_c('div',{staticClass:"ss__desktop__submenu__item__head"},[(_vm.submenu.image)?_c('img',{staticClass:"ss__desktop__submenu__item__image",attrs:{"src":_vm.submenu.image,"alt":_vm.submenu.name}}):_vm._e(),_c('div',{staticClass:"ss__desktop__submenu__item__name"},[_vm._v(_vm._s(_vm.submenu.name))])]),_c('div',{class:[
      'ss__desktop__submenu__item__children',
      _vm.submenu.layout ? `ss__desktop__submenu__item__children--${_vm.submenu.layout}` : ''
    ]},_vm._l((_vm.submenu.children),function(item){return _c(item.card,{key:item.name,tag:"component",class:[
        'ss__desktop__submenu__item__item',
        `comp__${item.card}`
      ],style:(item.style),attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }